<template>
  <div class="customer-lots-table-wrapper">
    <Block v-if="isLoading" />
    <DxDataGrid
      :dataSource="lots"
      :showBorders="true"
      show-row-lines
      ref="dataGrid"
      :scrolling="{ useNative: true }"
      :paging="{ enabled: false }"
      :column-auto-width="true"
      style="max-height: 600px"
    >
      <DxColumn cell-template="actions-template" />
      <template #actions-template="{ data }">
        <div class="row-actions d-flex justify-center align-center" >
          <Button 
            prepend-icon="mdi-eye" 
            size="small" 
            @click="$emit('row-selected', data.data)"
          >
            Ver Cuotas
          </Button>
        </div>
      </template>

      <DxColumn dataField="ID_RealStateLot" caption="ID de lote" />

      <DxColumn dataField="LotName" caption="Nombre de lote" />
      
      <DxColumn dataField="LotNumber" caption="Número de lote" />
      
      <DxColumn dataField="PolygonNumber" caption="Número de polígono" />

      <DxColumn dataField="LotArea" caption="Area" />

      <DxColumn dataField="ContractDate" caption="Fecha de contratación" />

    </DxDataGrid>
  </div>
</template>

<script>
import Block from '@/components/Block.vue';
import { DxDataGrid, DxColumn } from "devextreme-vue/data-grid";
import Button from '@/components/Button.vue';
import enums from '@/helpers/enums.js';

export default {
  name: 'CustomerLots',
  components: {
    Block,
    DxDataGrid,
    DxColumn,
    Button,
    // Alert,
  },
  props: {
    lots: {
      type: Array,
      required: false,
      default: () => [],
    },
    services: {
      type: Array,
      required: false,
      default: () => [],
    },
    customers: {
      type: Array,
      required: false,
      default: () => [],
    },
    sellers: {
      type: Array,
      required: false,
      default: () => [],
    },
    saleTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    reservationTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert,
        enums,
      },
    };
  },
   methods: {
    getServiceName(ID_Service) {
      const service = this.services.find(s => {
        return `${s.ID_Service}` === ID_Service;
      })

      return service 
        ? service.Name || service.NameService
        : ''
    },
    getCustomerName(ID_Customer) {
      const customer = this.customers.find(s => {
        return `${s.ID_Customer}` === ID_Customer
      })

      return customer 
        ? customer.BusinessName
        : ''
    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert;
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert;
      
    },
    closeAlert() {
      this.alert.show = false;
    },
  },
  mounted() {
  }
}
</script>
